export const addParagraph = (text?: string) => {
  return text?.split('\n').join('<br>') || ''
}
